import { createFileRoute } from "@tanstack/react-router";
import { MarketingAnalyticsServicePage } from "./services_.analytics";

export const Route = createFileRoute("/services_/analytics-services")({
  head: () => ({
    meta: [
      {
        title: "Analytics Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Advanced Marketing Analytics & Multi-Touch Attribution.",
      },
    ],
  }),
  component: MarketingAnalyticsServicePage,
});
